<template>
  <home-layout>
    <template slot="col-left">
      <home-message />
    </template>
    <div v-if="token">
      <div
        v-if="!done"
        class="card"
      >
        <label for="password1">Escribe tu nueva contraseña:</label>
        <input
          v-model="password1"
          v-validate="'required|confirmed:contraseña'"
          type="password"
          data-vv-as="contraseña1"
          name="contraseña"
          class="form-control"
          @click="cleanError"
        >
        <br>
        <label for="password2">Repite tu contraseña:</label>
        <input
          id="password2"
          v-model="password2"
          v-validate="'required|confirmed:contraseña'"
          type="password"
          data-vv-as="contraseña"
          name="confirmación contraseña"
          class="form-control"
        >
        <small class="form-text text-danger">
          {{ password1 !== password2 ?
            'Contraseñas no coinciden.' : '' }}
        </small>
        <small
          v-for="(e, index) in error"
          :key="index"
          class="form-text text-danger"
          @click="error=false"
        >{{ e }}</small>

        <div class="pt-3">
          <base-button
            block
            class="mb-4"
            @click="changePassword()"
          >
            Cambiar contraseña
          </base-button>

          <p class="text-center">
            <a
              href="#"
              @click.stop.prevent="goHome()"
            >Ir a Login</a>
          </p>
        </div>
      </div>
      <div
        v-else
        class="text-center"
      >
        <p class="do-p">
          ¡Tu contraseña ha sido cambiada con éxito!
        </p>
        <p class="do-p">
          Te redireccionaremos al inicio
          automáticamente en {{ count_down }} segundos.
          O puedes hacer
          <a
            href="#"
            @click.prevent="goHome()"
          >click acá</a> para ir inmediatamente.
        </p>
      </div>
    </div>

    <!-- Recuperacion -->
    <div v-else>
      <h2 class="do-h2">
        Recuperación de contraseña
      </h2>
      <p class="do-p">
        Ingresa el correo con el que te registraste,
        enviaremos un enlace para recuperar tu
        contraseña:
      </p>
      <div class="card">
        <div v-if="!done">
          <label for="email">Correo Electrónico:</label>
          <input
            v-model="email"
            type="email"
            name="email"
            class="form-control"
            @click="cleanError"
          >
        </div>
        <div
          v-else
          class="text-center"
        >
          <p>
            Hemos enviado un correo a
            <b>{{ email }}</b> para que puedas recuperar tu contraseña.
            <br>Si no lo encuentras en tu bandeja de entrada, revisa tu spam.
          </p>
          <p>Si aún no ves el correo, intenta enviarlo otra vez, presionando el botón de abajo.</p>
        </div>

        <div class="pt-3">
          <base-button
            class="mb-4"
            block
            :disabled="emailInvalid || submitButtonDisabled"
            :style-prop="{ 'margin-right': 0 }"
            @click="sendEmail"
          >
            Enviar correo
          </base-button>

          <p class="text-center mb-0">
            <a
              href="#"
              @click.stop.prevent="goHome()"
            >Ir a Login</a>
          </p>
        </div>
      </div>
    </div>
  </home-layout>
</template>
<script>
import { authenticationService } from '../_services';

export default {
    name: 'PasswordResetDialog',
    data() {
        return {
            email: '',
            password1: '',
            password2: '',
            count_down: 10,
            count_down_interval: null,
            done: false,
            error: false,

            submitButtonDisabled: false,
        };
    },
    computed: {
        token() {
            return this.$route.query.token;
        },
        emailInvalid() {
            return !/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
                this.email,
            );
        },
    },
    methods: {
        cleanError() {
            this.error = false;
        },
        toggleDisabledSubmit() {
            this.submitButtonDisabled = !this.submitButtonDisabled;
        },
        sendEmail() {
            this.toggleDisabledSubmit();
            authenticationService
                .recover(this.email)
                .then(() => {
                    this.error = false;
                    this.done = true;
                })
                .catch(this.toggleDisabledSubmit);
        },
        changePassword() {
            this.toggleDisabledSubmit();
            authenticationService
                .reset_password(this.password1, this.token)
                .then(() => {
                    this.error = false;
                    this.done = true;
                    this.decreaseCount();
                })
                .catch((error) => {
                    this.toggleDisabledSubmit();
                    if (error.response) {
                        // The request was made and the server responded with a status code
                        // that falls out of the range of 2xx
                        if (error.response.data && error.response.data.password) {
                            this.error = error.response.data.password;
                        } else {
                            this.error = [
                                'Ocurrió un error desconocido en el servidor. Por favor inténtelo más tarde.',
                            ];
                        }
                    } else {
                        this.error = [
                            'Ocurrió un error desconocido en el servidor. Por favor inténtelo más tarde.',
                        ];
                    }
                });
        },
        decreaseCount() {
            if (this.count_down_interval === null) {
                this.count_down_interval = setInterval(this.decreaseCount, 1000);
            }
            if (this.count_down === 0) {
                clearInterval(this.count_down_interval);
                this.goHome();
            } else {
                this.count_down = this.count_down - 1;
            }
        },
        goHome() {
            this.$router.push({ name: 'home' });
        },
    },
};
</script>
<style lang="scss">
@import "../scss/style";
.home {
  &__jumbotron {
    height: calc(100vh - 56px);
    position: relative;
    margin-left: -1rem;
    margin-right: -1rem;
    padding: 1rem;
    min-height: 600px;
    background: url("../assets/img/home-bg.jpg") no-repeat;
    background-color: $dark;
    background-size: cover;
    background-position: center;
    @media (min-width: 768px) {
      padding: 0;
    }
  }
  &__container {
    text-align: center;
    padding-top: 3rem;

    @media (min-width: 768px) {
      max-width: 810px;
      margin: 0 auto;
      position: absolute;
      left: 50%;
      top: 50%;
      padding-top: 0;
      transform: translate(-50%, -50%);
    }
  }
  &__title {
    color: #ffffff;
    font-family: $font-family-sans-serif;
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 0.14px;
    margin-bottom: 3rem;
    // line-height: 43px;
    @media (min-width: 768px) {
      font-size: 2.25rem;
    }
  }
  &__subtitle {
    color: #ffffff;
    font-family: $font-family-sans-serif;
    font-size: 1.2rem;
  }
}
</style>
